define.alias("shared/components/shared/publish/switcher/item/publish-method", "preview-grid/components/shared/publish/switcher/item/publish-method");